<template>
	<div class="daepicker-block">
		<el-date-picker
			v-model="values"
			@change="dateChanged"
			type="daterange"
			range-separator="-"
			:start-placeholder="msg.date_picker_ckeckin"
			:end-placeholder="msg.date_picker_ckeckout"
			format="dd.MM.yyyy."
			:picker-options="pickerOptions">
		</el-date-picker>
	</div>
</template>

<script>
	import { eventBus } from '../main.js';
	import { mapState } from "vuex";
	export default {
		data() {
			return {
				pickerOptions: {
					firstDayOfWeek: 1
				},
				pickerOptions2: {
					shortcuts: [{
						text: 'Last week',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: 'Last month',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: 'Last 3 months',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				values: []
			};
		},
		methods: {
			dateChanged() {
				eventBus.$emit('date-changed', this.values);
			}
		},
		created() {
		},
		mounted() {
			// $(".el-range-input" ).after( "<span class='el-range-input__carret'></span>" );
		},
		computed: {
			...mapState({
				msg: state => state.msg,
			})
		}
	};
</script>